import getCookies from '@gameday/utils/getCookies';

export const oktaAuthPromise = () => {
  return new Promise((resolve) => {
    if (typeof window !== undefined && window.mlbOkta) {
      const okta = window.mlbOkta;  
      okta.isLoggedIn()
          .then((res) => {
              if (!res) {
                resolve(null);
              }
              resolve(res?.accessToken?.accessToken);
          })
          .catch((error) => {
              resolve(null);
          });

    } else {
      resolve(null);
    }
  });
};

const accessTokenReady = () => {
    return Promise.allSettled([
        oktaAuthPromise()
    ]).then(([oktaData]) => {
        const nativeOktaCookie = getCookies().get('native-okta-access-token');
        return oktaData?.value || nativeOktaCookie || null;
    }).catch(() => {
        return null;
    });
};

export default accessTokenReady;